
  // CHECKING FOR ANY EVENTS ACCESSING CART.JS VIA AJAX (CART)
      const open = window.XMLHttpRequest.prototype.open;

      function openReplacement() {
        this.addEventListener("load", function () {
          if (
            [
              "/cart/add.js",
              "/cart/update.js",
              "/cart/change.js",
              "/cart/clear.js",
            ].includes(this._url)
          ) {
            // calculateShipping(this.response);
            setTimeout(() => {
              $(".shipping-promo-container").load("/ .shipping-promo-container-rte");
            }, 500);
          }
        });
        return open.apply(this, arguments);
      }

      window.XMLHttpRequest.prototype.open = openReplacement;

// FS setting opacity for Out of stock products

// var getProductCards = setInterval(function () {
//     if ($('#fast-simon-serp-app')[0]) {
//     var productGrid = $('#fast-simon-serp-app')[0].shadowRoot.querySelector('#fs-serp-page');
//     if (productGrid) {
//         var productCards = productGrid.querySelectorAll('.product-card');
//         productCards.forEach(function(k,v){
//             // console.log(productCards.length);
//             var element = $(k);
//             if ( element.find('.out-of-stock-wrapper').length > 0 ) {
//                 // EDITS HERE: 
//                 element.find('.fs-product-main-image-wrapper').css('opacity', '0.5'); 
//             }
//         })
//     }
// }}, 50);